import { useEffect, useState } from 'react';
import { useReduxState } from 'hooks';

interface Props {
  inAnswerView?: boolean;
  task?: any;
}

const FillInSummary = ({ inAnswerView, task }: Props) => {
  const { messages, theme } = useReduxState();

  const [percentageCorrect, setPercentageCorrect] = useState([]);

  const correctOptionsPerBlank = task.data.correctAnswers.map((answer, i) => {
    let availableOptions = [];
    const { options } = answer;

    options.forEach((option) => availableOptions.push(option.value));
    return availableOptions.join(', ');
  });

  useEffect(() => percentageOfCorrectAnswers(), []);

  const percentageOfCorrectAnswers = () => {
    const options = task.data.correctAnswers.map((answer) => {
      return { id: answer.id, correctFraction: 0 };
    });
    const { answers } = task;

    answers.forEach((answer, i) => {
      options.forEach((option) => {
        const match = answer.correctAnswers.find(
          (entry) => entry.id === option.id
        );
        if (match.correct) option.correctFraction++;
        if (i === answers.length - 1) option.correctFraction /= answers.length;
      });
    });

    setPercentageCorrect(options);
  };

  const formatPercentageAnswer = (id) => {
    const { correctFraction } = percentageCorrect.find(
      (item) => item.id === id
    );
    return `${Math.round(correctFraction * 100)}`;
  };

  return (
    <div className="summary">
      <div className="content">
        {task.data?.contentData
          ? task.data.contentData.map((paragraph, i) => {
              return (
                <div style={{ minHeight: '1.5em', margin: '5px 0' }} key={i}>
                  {paragraph.map((paragraphContentItem, j) => {
                    if (paragraphContentItem.type === 'answer') {
                      return (
                        <div key={`${i}-${j}`} className="option-percentage">
                          <div className="option-percentage-content">
                            {percentageCorrect?.length
                              ? `${formatPercentageAnswer(
                                  paragraphContentItem.id
                                )}%`
                              : ''}
                            <div className="option-percentage-indicator">
                              <div
                                className="option-percentage-indicator-fill"
                                style={{
                                  width: percentageCorrect?.length
                                    ? `${formatPercentageAnswer(
                                        paragraphContentItem.id
                                      )}%`
                                    : 0
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    }
                    return (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: paragraphContentItem.content
                        }}
                        key={j}
                      />
                    );
                  })}
                </div>
              );
            })
          : null}
      </div>

      {inAnswerView ? (
        <div className="correct-answers">
          <div className="correct-answers-title">
            {messages.commonCorrectAnswers}
          </div>
          <ol className="correct-answers-list">
            {correctOptionsPerBlank.map((answer, i) => (
              <li
                className="correct-answers-list-item"
                key={`fillin-options-${task.id}-${i}`}
              >
                {answer}
              </li>
            ))}
          </ol>
        </div>
      ) : null}

      <style jsx>{`
        .content {
          background-color: white;
          border-radius: ${theme.cardBorderRadius};
          color: ${theme.textColorLight};
          font-size: 1.5rem;
          line-height: 1.5;
          padding: 5px 10px;
          counter-reset: numerals;
        }
        .option-percentage {
          display: inline-block;
          margin: 0 5px 0 2px;
          max-width: max-content;
        }
        .option-percentage-content {
          align-items: center;
          background-color: ${theme.lightGrey};
          border-radius: 4px;
          display: flex;
          font-size: 1.4rem;
          font-weight: 600;
          margin: 3px;
          padding: 2px 6px;
          white-space: nowrap;
        }
        .option-percentage-content::before {
          counter-increment: numerals;
          content: counter(numerals) '.';
          margin-right: 5px;
        }
        .option-percentage-indicator {
          background-color: ${theme.lightGreyDark};
          border-radius: 3px;
          display: inline-block;
          height: 6px;
          margin-left: 5px;
          overflow: hidden;
          width: 50px;
        }
        .correct-answers {
          margin-top: 20px;
        }
        .correct-answers-title {
          color: ${theme.textColorLight};
          font-weight: 600;
        }
        .correct-answers-list {
          margin: 5px 0 0 0;
          padding: 0;
        }
        .correct-answers-list-item {
          color: ${theme.textColorLighter};
          font-weight: 600;
          margin-left: 15px;
          margin-top: 3px;
        }
        @keyframes optionPercentageFill {
          0% {
            width: 0;
          }
        }
        .option-percentage-indicator-fill {
          animation: optionPercentageFill 1s;
          background-color: rgba(0, 0, 0, 0.4);
          height: 100%;
        }
      `}</style>
    </div>
  );
};

export default FillInSummary;
